export default __webpack_public_path__ + "static/media/iconSmallScreen.4a52347a.svg";